import React, { useEffect, useState } from 'react';
import styles from './MiniGifts.module.scss';
import Gift from '../Icons/Gift';
import { useSharedCart } from '../../entrypoints/theme';
import { cartStore } from '../../hooks/cartStore';

export default function MiniGifts({ inMiniCart = false }) {
  const { cartState } = useSharedCart();
  const activeClass = styles.active || 'active';
  const [currentStep, setCurrentStep] = useState(0);
  const [stepsData, setStepsData] = useState([]);

  useEffect(() => {
    // Define steps based on cartState thresholds
    const definedSteps = [
      { threshold: cartState?.gift_threshold_1, value: 10, id: 1 }, // Assuming $10 gift for threshold 1
      { threshold: cartState?.gift_threshold_2, value: 15, id: 2 }, // Assuming $15 gift for threshold 2
      { threshold: cartState?.gift_threshold_3, value: 25, id: 3 }, // Assuming $25 gift for threshold 3
    ].filter(step => typeof step.threshold === 'number' && step.threshold > 0); // Filter out invalid/missing thresholds

    setStepsData(definedSteps);

    const totalPriceDollars = parseFloat(cartState?.main_items_total ?? 0);
    let step = 0;
    // Determine the highest achieved step
    definedSteps.forEach(s => {
      if (totalPriceDollars >= s.threshold) {
        step = s.id;
      }
    });
    setCurrentStep(step);

    // Remove free products from cart if no threshold is met
    if (step < 1) {
      const freeProducts = cartState?.items?.filter(item => item.properties?._isFreeGift);
      if (freeProducts?.length > 0) {
        // Ensure keys are valid before removing
        const keysToRemove = freeProducts.map(product => product.key).filter(Boolean);
        if (keysToRemove.length > 0) {
          cartStore.removeItem(keysToRemove);
        }
      }
    }
  }, [cartState]); // Rerun when cartState changes

  const totalPriceDollars = parseFloat(cartState?.main_items_total ?? 0);

  // Hide component if no steps are defined
  if (stepsData.length === 0) {
    return null;
  }

  return (
    <div className={styles.miniGiftsContainer + " " + (inMiniCart ? styles.miniCartContainer : '')}>
      <div className={styles.miniGiftsContainerInner}>
        <div className={styles.imageContainer}>
          <Gift />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.stepsContainer}>
            {stepsData.map((stepInfo) => {
              const isAchieved = currentStep >= stepInfo.id;
              const amountNeeded = Math.max(0, stepInfo.threshold - totalPriceDollars);
              const formattedAmountNeeded = `$${amountNeeded.toFixed(2)}`;

              return (
                <div key={stepInfo.id} className={`${styles.giftItem} ${isAchieved ? activeClass : ''}`}>
                  <span className={styles.stepDot}></span>
                  <span className={styles.stepLabel}>
                    {isAchieved ? (
                      <strong>{`You qualify for free $${stepInfo.value} gift!`}</strong>
                    ) : (
                      <>
                        {`Spend ${formattedAmountNeeded} more - `}
                        <strong>{`Unlock a free $${stepInfo.value} gift`}</strong>
                      </>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {currentStep >= 1 && (
        <button type="button" className={`${styles.btn} btn--hollow`} onClick={cartStore.openGiftPopup}>
          Choose Gift
        </button>
      )}
      {currentStep < 1 && stepsData.length > 0 && (
        <p className={inMiniCart ? styles.miniCartInitialMessage : styles.initialMessage}>Spend ${stepsData[0].threshold.toFixed(2)} to unlock your first gift!</p>
      )}
    </div>
  );
}